var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container potentialSupplierManageDetail" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("supplierManage.basicInfo"), name: "1" } },
            [
              _c(
                "div",
                { staticClass: "searchBox_top" },
                [
                  _vm.canEdit
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.SavePotentialSupplier,
                              expression: "SavePotentialSupplier",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.saveDetail },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.saveDraft")))]
                      )
                    : _vm._e(),
                  _vm.canEdit
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.SubmitPotentialSupplier,
                              expression: "SubmitPotentialSupplier",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.submitDetail },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.submit")))]
                      )
                    : _vm._e(),
                  _vm.canUpdate && _vm.isGroup
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.SubmitPotentialSupplier,
                              expression: "SubmitPotentialSupplier",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.submitDetail },
                        },
                        [_vm._v(_vm._s(_vm.$t("supplierManage.dataUpdate")))]
                      )
                    : _vm._e(),
                  _vm.canAudit
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.ApprovePotentialSupplier,
                              expression: "ApprovePotentialSupplier",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.approvalSuppliers },
                        },
                        [_vm._v(_vm._s(_vm.$t("supplierManage.supplierAudit")))]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.historyBack },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.close")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "scrollYBox" },
                [
                  _vm.emplFlag != "SUP" && _vm.groupType == "SUPPLIER"
                    ? _c(
                        "el-card",
                        { staticClass: "box-card" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "clearfix",
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "supplierManage.supplierCategoryInfo"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "el-form",
                            {
                              ref: "CategoryInfoForm",
                              attrs: {
                                model: _vm.CategoryInfoForm,
                                rules: _vm.CategoryInfoRules,
                                "label-width": "120px",
                              },
                            },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.Category1"
                                        ),
                                        prop: "categoryLevel1Id",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value:
                                              _vm.CategoryInfoForm
                                                .categoryLevel1Id,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.CategoryInfoForm,
                                                "categoryLevel1Id",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "CategoryInfoForm.categoryLevel1Id",
                                          },
                                        },
                                        _vm._l(
                                          _vm.categoryList1,
                                          function (item, index) {
                                            return _c(
                                              "el-checkbox",
                                              {
                                                key: index,
                                                attrs: {
                                                  disabled: !_vm.canAudit,
                                                  label: item.tmCategoryId,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.changeCategory1(
                                                      $event,
                                                      item.tmCategoryId
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.Category2"
                                        ),
                                        prop: "categoryLevel2Id",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value:
                                              _vm.CategoryInfoForm
                                                .categoryLevel2Id,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.CategoryInfoForm,
                                                "categoryLevel2Id",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "CategoryInfoForm.categoryLevel2Id",
                                          },
                                        },
                                        _vm._l(
                                          _vm.categoryList2,
                                          function (item, index) {
                                            return _c(
                                              "el-checkbox",
                                              {
                                                key: index,
                                                attrs: {
                                                  disabled: !_vm.canAudit,
                                                  label: item.tmCategoryId,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.changeCategory2(
                                                      $event,
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "Categorypname",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.pname) + "："
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(_vm._s(item.name)),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "supplierManage.confidentialityAgreement"
                                )
                              )
                            ),
                          ]),
                          _c(
                            "el-tag",
                            {
                              staticStyle: {
                                "margin-left": "20px",
                                "font-size": "15px",
                              },
                              attrs: { type: "danger" },
                            },
                            [
                              _vm._v(
                                "新供应商注册需完成保密协议签署，才能再进行后续的注册信息填写与提交"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          ref: "lawFileList",
                          attrs: {
                            data: _vm.lawFileList,
                            border: "",
                            "highlight-current-row": "",
                            "max-height": "420",
                          },
                        },
                        [
                          _c(
                            "el-table-column",
                            {
                              attrs: {
                                label: _vm.$t("supplierManage.fileName"),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "supplierManage.confidentialityAgreement"
                                  )
                                )
                              ),
                            ]
                          ),
                          _c(
                            "el-table-column",
                            {
                              attrs: {
                                label: _vm.$t("common.file"),
                                prop: "current",
                              },
                            },
                            [
                              [
                                _c(
                                  "el-link",
                                  {
                                    attrs: { type: "primary" },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.downloadTemplate(
                                          "/templates/download/附件二 麦当劳保密协议_CN.PDF",
                                          "附件二 麦当劳保密协议_CN.PDF"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("附件二 麦当劳保密协议_CN.PDF")]
                                ),
                                _c(
                                  "el-link",
                                  {
                                    attrs: { type: "primary" },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.downloadTemplate(
                                          "/templates/download/附件二 麦当劳保密协议_ENCN.PDF",
                                          "附件二 麦当劳保密协议_ENCN.PDF"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("附件二 麦当劳保密协议_ENCN.PDF")]
                                ),
                              ],
                            ],
                            2
                          ),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("common.status"),
                              prop: "statusI18n",
                            },
                          }),
                          _vm.canEdit
                            ? _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("base.linePrice.operation"),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm.isGroup
                                            ? _c(
                                                "el-link",
                                                {
                                                  directives: [
                                                    {
                                                      name: "acl",
                                                      rawName: "v-acl",
                                                      value:
                                                        _vm.SubmitPotentialSupplier,
                                                      expression:
                                                        "SubmitPotentialSupplier",
                                                    },
                                                  ],
                                                  staticStyle: {
                                                    "margin-right": "20px",
                                                  },
                                                  attrs: { type: "primary" },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.apply(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "supplierManage.apply"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-link",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: scope.row.tmLawFileId,
                                                  expression:
                                                    "scope.row.tmLawFileId",
                                                },
                                                {
                                                  name: "acl",
                                                  rawName: "v-acl",
                                                  value:
                                                    _vm.SubmitPotentialSupplier,
                                                  expression:
                                                    "SubmitPotentialSupplier",
                                                },
                                              ],
                                              attrs: { type: "primary" },
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.seeLegalFileDetail(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("common.see"))
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4130895871
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("supplierManage.supplierBasicInfo"))
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-form",
                        {
                          ref: "basicInfoForm",
                          attrs: {
                            model: _vm.basicInfoForm,
                            rules: _vm.basicInfoRules,
                            "label-width": "140px",
                          },
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.supplierChinese"
                                        ),
                                        prop: "supplierName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          disabled: !(
                                            _vm.canEdit || _vm.canUpdate
                                          ),
                                          maxlength: "60",
                                        },
                                        model: {
                                          value: _vm.basicInfoForm.supplierName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "supplierName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "basicInfoForm.supplierName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.supplierAbbreviation"
                                        ),
                                        prop: "supplierNameShort",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          disabled: "",
                                          maxlength: "60",
                                        },
                                        model: {
                                          value:
                                            _vm.basicInfoForm.supplierNameShort,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "supplierNameShort",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "basicInfoForm.supplierNameShort",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.supplierInvitationCode"
                                        ),
                                        prop: "invitationCode",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "", disabled: "" },
                                        model: {
                                          value:
                                            _vm.basicInfoForm.invitationCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "invitationCode",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "basicInfoForm.invitationCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.supplierEnglish"
                                        ),
                                        prop: "supplierNameEn",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          disabled: !(
                                            _vm.canEdit || _vm.canUpdate
                                          ),
                                          maxlength: "100",
                                        },
                                        model: {
                                          value:
                                            _vm.basicInfoForm.supplierNameEn,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "supplierNameEn",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "basicInfoForm.supplierNameEn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.supplierType"
                                        ),
                                        prop: "groupType",
                                      },
                                    },
                                    [
                                      _c("ic-select", {
                                        attrs: {
                                          clearable: "",
                                          table: "TM_SUPPLIER",
                                          field: "GROUP_TYPE",
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.basicInfoForm.groupType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "groupType",
                                              $$v
                                            )
                                          },
                                          expression: "basicInfoForm.groupType",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.supplierInviter"
                                        ),
                                        prop: "inviter",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "", disabled: "" },
                                        model: {
                                          value: _vm.basicInfoForm.inviter,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "inviter",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "basicInfoForm.inviter",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.auditStatus"
                                        ),
                                        prop: "auditStatus",
                                      },
                                    },
                                    [
                                      _c("ic-select", {
                                        attrs: {
                                          clearable: "",
                                          table: "TM_SUPPLIER",
                                          field: "AUDIT_STATUS",
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.basicInfoForm.auditStatus,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "auditStatus",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "basicInfoForm.auditStatus",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.socialUniformCreditCode"
                                        ),
                                        prop: "socialUniformCreditCode",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          disabled: !(
                                            _vm.canEdit || _vm.canUpdate
                                          ),
                                        },
                                        model: {
                                          value:
                                            _vm.basicInfoForm
                                              .socialUniformCreditCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "socialUniformCreditCode",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "basicInfoForm.socialUniformCreditCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.canEdit || _vm.canUpdate
                        ? [
                            _vm.formlinkUsers.linkUsersList.length < 5 &&
                            _vm.isGroup
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "acl",
                                        rawName: "v-acl",
                                        value: _vm.SubmitPotentialSupplier,
                                        expression: "SubmitPotentialSupplier",
                                      },
                                    ],
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addSupplierContacts()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.addNew")))]
                                )
                              : _vm._e(),
                            _vm.isGroup
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "acl",
                                        rawName: "v-acl",
                                        value: _vm.SubmitPotentialSupplier,
                                        expression: "SubmitPotentialSupplier",
                                      },
                                    ],
                                    attrs: { type: "danger" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.delSupplierContacts()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.del")))]
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _c(
                        "el-form",
                        {
                          ref: "formlinkUsers",
                          attrs: {
                            model: _vm.formlinkUsers,
                            rules: _vm.ruleslinkUsers,
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              ref: "linkUsersList",
                              attrs: {
                                data: _vm.formlinkUsers.linkUsersList,
                                border: "",
                                "highlight-current-row": "",
                                "max-height": "420",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "trLinkUserId",
                                  type: "selection",
                                  "min-width": "55",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "name",
                                  label: _vm.$t(
                                    "supplierManage.supplierContacts"
                                  ),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "linkUsersList." +
                                                scope.$index +
                                                ".name",
                                              rules: _vm.ruleslinkUsers.name,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                attrs: {
                                                  disabled: !(
                                                    _vm.canEdit || _vm.canUpdate
                                                  ),
                                                },
                                                model: {
                                                  value: scope.row.name,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "name",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.name",
                                                },
                                              },
                                              [_vm._v(" ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "tel",
                                  label: _vm.$t("settlementUnit.supplierTel"),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "linkUsersList." +
                                                scope.$index +
                                                ".tel",
                                              rules: _vm.ruleslinkUsers.tel,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                attrs: {
                                                  disabled: !(
                                                    _vm.canEdit || _vm.canUpdate
                                                  ),
                                                },
                                                model: {
                                                  value: scope.row.tel,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "tel",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.tel",
                                                },
                                              },
                                              [_vm._v(" ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "officeTel",
                                  label: "办公室电话",
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "linkUsersList." +
                                                scope.$index +
                                                ".officeTel",
                                              rules:
                                                _vm.ruleslinkUsers.officeTel,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                attrs: {
                                                  disabled: !(
                                                    _vm.canEdit || _vm.canUpdate
                                                  ),
                                                },
                                                model: {
                                                  value: scope.row.officeTel,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "officeTel",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.officeTel",
                                                },
                                              },
                                              [_vm._v(" ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "email",
                                  label: "邮箱",
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "linkUsersList." +
                                                scope.$index +
                                                ".email",
                                              rules: _vm.ruleslinkUsers.email,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                attrs: {
                                                  disabled: !(
                                                    _vm.canEdit || _vm.canUpdate
                                                  ),
                                                },
                                                model: {
                                                  value: scope.row.email,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "email",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.email",
                                                },
                                              },
                                              [_vm._v(" ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "title",
                                  label: _vm.$t("supplierManage.position"),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "linkUsersList." +
                                                scope.$index +
                                                ".title",
                                              rules: _vm.ruleslinkUsers.title,
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table: "TM_SUPPLIER",
                                                field: "CONTACT_POSITION",
                                                disabled:
                                                  !(
                                                    _vm.canEdit || _vm.canUpdate
                                                  ) ||
                                                  (scope.row.title == "KA" &&
                                                    scope.$index == 0),
                                                clearable: "",
                                              },
                                              model: {
                                                value: scope.row.title,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "title",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.title",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("supplierManage.supplierAddressInfo")
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm.canEdit || _vm.canUpdate
                        ? [
                            _vm.formAddress.plantList &&
                            _vm.groupType != "CARRIER" &&
                            _vm.isGroup
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "acl",
                                        rawName: "v-acl",
                                        value: _vm.SubmitPotentialSupplier,
                                        expression: "SubmitPotentialSupplier",
                                      },
                                    ],
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addAddress()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.addNew")))]
                                )
                              : _vm._e(),
                            _vm.groupType != "CARRIER" && _vm.isGroup
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "acl",
                                        rawName: "v-acl",
                                        value: _vm.SubmitPotentialSupplier,
                                        expression: "SubmitPotentialSupplier",
                                      },
                                    ],
                                    attrs: { type: "danger" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.delAddress()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.del")))]
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _c(
                        "el-form",
                        {
                          ref: "formAddress",
                          attrs: {
                            model: _vm.formAddress,
                            rules: _vm.rulesAddress,
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              ref: "plantList",
                              staticClass: "addressBox",
                              attrs: {
                                data: _vm.formAddress.plantList,
                                border: "",
                                "highlight-current-row": "",
                                "max-height": "420",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "tmSupplierId",
                                  type: "selection",
                                  "min-width": "55",
                                  selectable: _vm.selectFunc,
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "supplierName",
                                  label: _vm.$t("sys.roleList.roleCN"),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "plantList." +
                                                scope.$index +
                                                ".supplierName",
                                              rules:
                                                _vm.rulesAddress.supplierName,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                attrs: {
                                                  disabled: !(
                                                    _vm.canEdit || _vm.canUpdate
                                                  ),
                                                  maxlength: "20",
                                                },
                                                model: {
                                                  value: scope.row.supplierName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "supplierName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.supplierName",
                                                },
                                              },
                                              [_vm._v(" ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "supplierNameEn",
                                  label: _vm.$t("sys.roleList.roleEN"),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "plantList." +
                                                scope.$index +
                                                ".supplierNameEn",
                                              rules:
                                                _vm.rulesAddress.supplierNameEn,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                attrs: {
                                                  disabled: !(
                                                    _vm.canEdit || _vm.canUpdate
                                                  ),
                                                  maxlength: "100",
                                                },
                                                model: {
                                                  value:
                                                    scope.row.supplierNameEn,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "supplierNameEn",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.supplierNameEn",
                                                },
                                              },
                                              [_vm._v(" ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "plantType",
                                  label: _vm.$t("settlementUnit.addressType"),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "plantList." +
                                                scope.$index +
                                                ".plantType",
                                              rules: _vm.rulesAddress.plantType,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: { disabled: "" },
                                                model: {
                                                  value: scope.row.plantType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "plantType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.plantType",
                                                },
                                              },
                                              [
                                                _c("el-option", {
                                                  key: "REG",
                                                  attrs: {
                                                    label: "注册地址",
                                                    value: "REG",
                                                  },
                                                }),
                                                _vm.groupType == "SUPPLIER"
                                                  ? _c("el-option", {
                                                      key: "PLANT",
                                                      attrs: {
                                                        label: "工厂地址",
                                                        value: "PLANT",
                                                      },
                                                    })
                                                  : _c("el-option", {
                                                      key: "WAREHOUSE",
                                                      attrs: {
                                                        label: "仓库",
                                                        value: "WAREHOUSE",
                                                      },
                                                    }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "tmAreaId",
                                  label: _vm.$t("supplierManage.area"),
                                  "min-width": "180",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.tmAreaId
                                          ? _c(
                                              "el-link",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.selectArea(
                                                      scope.row,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.areaName)
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "el-link",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.selectArea(
                                                      scope.row,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "supplierManage.area"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "address",
                                  label: _vm.$t("settlementUnit.detailAddress"),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "plantList." +
                                                scope.$index +
                                                ".address",
                                              rules: _vm.rulesAddress.address,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                attrs: {
                                                  disabled: !(
                                                    _vm.canEdit || _vm.canUpdate
                                                  ),
                                                  maxlength: "33",
                                                },
                                                model: {
                                                  value: scope.row.address,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "address",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.address",
                                                },
                                              },
                                              [_vm._v(" ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "linkman",
                                  label: _vm.$t("settlementUnit.contacts"),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.linkman
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "dark",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: { slot: "content" },
                                                    slot: "content",
                                                  },
                                                  _vm._l(
                                                    scope.row
                                                      .supplierContactList,
                                                    function (item, index) {
                                                      return _c(
                                                        "span",
                                                        { key: index },
                                                        [
                                                          _vm._v(
                                                            "联系人：" +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              "，电话：" +
                                                              _vm._s(item.tel) +
                                                              "，邮箱：" +
                                                              _vm._s(
                                                                item.email
                                                              ) +
                                                              "，办公室电话：" +
                                                              _vm._s(
                                                                item.officeTel
                                                              )
                                                          ),
                                                          _c("br"),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _c(
                                                  "el-link",
                                                  {
                                                    attrs: { type: "primary" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.addAddressUser(
                                                          scope.row,
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(scope.row.linkman)
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "el-link",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addAddressUser(
                                                      scope.row,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("添加")]
                                            ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "telephoneNo",
                                  label: _vm.$t("settlementUnit.supplierTel"),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.telephoneNo
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "dark",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: { slot: "content" },
                                                    slot: "content",
                                                  },
                                                  _vm._l(
                                                    scope.row
                                                      .supplierContactList,
                                                    function (item, index) {
                                                      return _c(
                                                        "span",
                                                        { key: index },
                                                        [
                                                          _vm._v(
                                                            "联系人：" +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              "，电话：" +
                                                              _vm._s(item.tel) +
                                                              "，邮箱：" +
                                                              _vm._s(
                                                                item.email
                                                              ) +
                                                              "，办公室电话：" +
                                                              _vm._s(
                                                                item.officeTel
                                                              )
                                                          ),
                                                          _c("br"),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _c(
                                                  "el-link",
                                                  {
                                                    attrs: { type: "primary" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.addAddressUser(
                                                          scope.row,
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.telephoneNo
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "contactOfficeTel",
                                  label: "办公室电话",
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.contactOfficeTel
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "dark",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: { slot: "content" },
                                                    slot: "content",
                                                  },
                                                  _vm._l(
                                                    scope.row
                                                      .supplierContactList,
                                                    function (item, index) {
                                                      return _c(
                                                        "span",
                                                        { key: index },
                                                        [
                                                          _vm._v(
                                                            "联系人：" +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              "，电话：" +
                                                              _vm._s(item.tel) +
                                                              "，邮箱：" +
                                                              _vm._s(
                                                                item.email
                                                              ) +
                                                              "，办公室电话：" +
                                                              _vm._s(
                                                                item.officeTel
                                                              )
                                                          ),
                                                          _c("br"),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _c(
                                                  "el-link",
                                                  {
                                                    attrs: { type: "primary" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.addAddressUser(
                                                          scope.row,
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row
                                                          .contactOfficeTel
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "emailAddress",
                                  label: _vm.$t("sys.userList.email"),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.emailAddress
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "dark",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: { slot: "content" },
                                                    slot: "content",
                                                  },
                                                  _vm._l(
                                                    scope.row
                                                      .supplierContactList,
                                                    function (item, index) {
                                                      return _c(
                                                        "span",
                                                        { key: index },
                                                        [
                                                          _vm._v(
                                                            "联系人：" +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              "，电话：" +
                                                              _vm._s(item.tel) +
                                                              "，邮箱：" +
                                                              _vm._s(
                                                                item.email
                                                              ) +
                                                              "，办公室电话：" +
                                                              _vm._s(
                                                                item.officeTel
                                                              )
                                                          ),
                                                          _c("br"),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _c(
                                                  "el-link",
                                                  {
                                                    attrs: { type: "primary" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.addAddressUser(
                                                          scope.row,
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.emailAddress
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "postCode",
                                  label: _vm.$t("settlementUnit.Postcode"),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "plantList." +
                                                scope.$index +
                                                ".postCode",
                                              rules: _vm.rulesAddress.postCode,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                attrs: {
                                                  disabled: !(
                                                    _vm.canEdit || _vm.canUpdate
                                                  ),
                                                  maxLength: "6",
                                                  onkeyup:
                                                    "this.value=this.value.replace(/\\D/g,'')",
                                                },
                                                model: {
                                                  value: scope.row.postCode,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "postCode",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.postCode",
                                                },
                                              },
                                              [_vm._v(" ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.isGroup
                                ? _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      label: _vm.$t(
                                        "settlementUnit.qualificationFile"
                                      ),
                                      "min-width": "80",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.existsFile == "Y"
                                                ? _c("i", {
                                                    staticClass:
                                                      "el-icon-folder-checked iconUploadSuccess",
                                                  })
                                                : _vm._e(),
                                              _c(
                                                "el-link",
                                                {
                                                  attrs: { type: "primary" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.seeQualificationFile(
                                                        scope.row,
                                                        scope.$index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("common.upload")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2233122551
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("common.otherAttachments"))),
                          ]),
                          _vm.fileList.length < 10 &&
                          (_vm.canEdit || _vm.canUpdate) &&
                          _vm.isGroup
                            ? _c(
                                "el-upload",
                                {
                                  directives: [
                                    {
                                      name: "acl",
                                      rawName: "v-acl",
                                      value: _vm.SubmitPotentialSupplier,
                                      expression: "SubmitPotentialSupplier",
                                    },
                                  ],
                                  ref: "upload",
                                  staticStyle: { "margin-left": "20px" },
                                  attrs: {
                                    action: "upload",
                                    "http-request": _vm.uploadConfirm,
                                    "show-file-list": false,
                                    multiple: "",
                                    name: "file",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "trigger",
                                        size: "small",
                                        type: "primary",
                                      },
                                      slot: "trigger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.selectFile"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          staticClass: "table",
                          attrs: {
                            data: _vm.fileList,
                            border: "",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "documentName",
                              label: _vm.$t("common.file"),
                              "min-width": "130px",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: { type: "primary" },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.downloadFile(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.documentName) + " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "userName",
                              label: _vm.$t("common.createBy"),
                              "min-width": "130px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "createDate",
                              label: _vm.$t("common.createDate"),
                              "min-width": "130px",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("dateFormatFilter")(
                                            scope.row.createDate,
                                            "YYYY-MM-DD HH:mm"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          (_vm.canEdit || _vm.canUpdate) && _vm.isGroup
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "tmDocumentId",
                                  "min-width": "130px",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-link",
                                            {
                                              directives: [
                                                {
                                                  name: "acl",
                                                  rawName: "v-acl",
                                                  value:
                                                    _vm.SubmitPotentialSupplier,
                                                  expression:
                                                    "SubmitPotentialSupplier",
                                                },
                                              ],
                                              attrs: { type: "primary" },
                                              nativeOn: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.deleteFile(
                                                    scope.row.tmDocumentId,
                                                    scope.$index,
                                                    _vm.fileList
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("common.del"))
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1790595765
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("common.approvalLog"), name: "2" } },
            [
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: {
                    data: _vm.auditLog,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "createDate",
                      label: _vm.$t("common.OperationTime"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormatFilter")(
                                  scope.row.createDate,
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "operatorName",
                      label: _vm.$t("common.OperatorName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "action",
                      label: _vm.$t("common.PedagogicalOperation"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "comments",
                      label: _vm.$t("common.opinion"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(scope.row.comments),
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.AreaDialog, width: "400px" },
          on: {
            "update:visible": function ($event) {
              _vm.AreaDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "AreaForm",
              attrs: { model: _vm.AreaForm, "label-width": "60px" },
            },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("settlementUnit.country"),
                            prop: "country",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: _vm.$t("common.sel") },
                              on: { change: _vm.countryChange },
                              model: {
                                value: _vm.AreaForm.country,
                                callback: function ($$v) {
                                  _vm.$set(_vm.AreaForm, "country", $$v)
                                },
                                expression: "AreaForm.country",
                              },
                            },
                            _vm._l(_vm.countryList, function (item) {
                              return _c("el-option", {
                                key: item.tmAreaId,
                                attrs: {
                                  clearable: "",
                                  label: item.name,
                                  value: item.tmAreaId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("settlementUnit.province"),
                            prop: "province",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: _vm.$t("common.sel") },
                              on: { change: _vm.provinceChange },
                              model: {
                                value: _vm.AreaForm.province,
                                callback: function ($$v) {
                                  _vm.$set(_vm.AreaForm, "province", $$v)
                                },
                                expression: "AreaForm.province",
                              },
                            },
                            _vm._l(_vm.provinceList, function (item) {
                              return _c("el-option", {
                                key: item.tmAreaId,
                                attrs: {
                                  clearable: "",
                                  label: item.name,
                                  value: item.tmAreaId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("settlementUnit.city"),
                            prop: "city",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: _vm.$t("common.sel") },
                              on: { change: _vm.cityChange },
                              model: {
                                value: _vm.AreaForm.city,
                                callback: function ($$v) {
                                  _vm.$set(_vm.AreaForm, "city", $$v)
                                },
                                expression: "AreaForm.city",
                              },
                            },
                            _vm._l(_vm.cityList, function (item) {
                              return _c("el-option", {
                                key: item.tmAreaId,
                                attrs: {
                                  clearable: "",
                                  label: item.name,
                                  value: item.tmAreaId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("DC.tmAreaId"),
                            prop: "tmAreaId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: _vm.$t("common.sel") },
                              on: { change: _vm.AreaChange },
                              model: {
                                value: _vm.AreaForm.tmAreaId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.AreaForm, "tmAreaId", $$v)
                                },
                                expression: "AreaForm.tmAreaId",
                              },
                            },
                            _vm._l(_vm.AreaList, function (item) {
                              return _c("el-option", {
                                key: item.tmAreaId,
                                attrs: {
                                  clearable: "",
                                  label: item.name,
                                  value: item.tmAreaId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _vm.canEdit || _vm.canUpdate
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.SubmitPotentialSupplier,
                          expression: "SubmitPotentialSupplier",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.saveArea },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.save")))]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.AreaDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.qualificationsDialog,
            width: "50%",
            "before-close": _vm.closeQualificationsDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.qualificationsDialog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "table",
              attrs: {
                data: _vm.qualificationsList,
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "HeaderName",
                  label: _vm.$t("common.file"),
                  "max-width": "130px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "documentName",
                  label: _vm.$t("supplierManage.fileName"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.tmDocumentId
                          ? _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.downloadQualifications(scope.row)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.documentName) + " ")]
                            )
                          : _c("span", [
                              _vm._v(_vm._s(scope.row.documentName)),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm.canEdit || _vm.canUpdate
                ? _c("el-table-column", {
                    attrs: {
                      "max-width": "130px",
                      label: _vm.$t("common.operation"),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "acl",
                                      rawName: "v-acl",
                                      value: _vm.SubmitPotentialSupplier,
                                      expression: "SubmitPotentialSupplier",
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.getFileIndex(scope.$index)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "upload",
                                      staticStyle: { "margin-left": "20px" },
                                      attrs: {
                                        action: "upload",
                                        "http-request":
                                          _vm.uploadQualifications,
                                        "show-file-list": false,
                                        multiple: "",
                                        name: "file",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            slot: "trigger",
                                            size: "small",
                                            type: "primary",
                                          },
                                          slot: "trigger",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.selectFile"))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2411764828
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.closeQualificationsDialog },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelDcMultipleDialog,
            "append-to-body": "",
            width: "85%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelDcMultipleDialog = $event
            },
          },
        },
        [
          _vm.DestroyIncomeStatistics == true
            ? _c("SelDc", {
                ref: "selectDcMultipleRef",
                attrs: { multipleSelectionFlag: true },
                on: { subCallMethod: _vm.selectDcMethod },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("supplierManage.approvalWindow"),
            visible: _vm.approvalVisible,
            width: "25%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.approvalVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "approvaForm",
              attrs: {
                model: _vm.approvaForm,
                rules: _vm.approvaRules,
                inline: "",
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("storeFeedback.auditor"),
                    prop: "auditor",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.approvaForm.auditor,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "auditor", $$v)
                      },
                      expression: "approvaForm.auditor",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("common.approvalTime"),
                    prop: "approvalTime",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.approvaForm.approvalTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "approvalTime", $$v)
                      },
                      expression: "approvaForm.approvalTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("common.approvalResults"),
                    prop: "approvalResults",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.ResultsChange },
                      model: {
                        value: _vm.approvaForm.approvalResults,
                        callback: function ($$v) {
                          _vm.$set(_vm.approvaForm, "approvalResults", $$v)
                        },
                        expression: "approvaForm.approvalResults",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "PASS" } }, [
                        _vm._v(_vm._s(_vm.$t("common.pass"))),
                      ]),
                      _c("el-radio", { attrs: { label: "REJECT" } }, [
                        _vm._v(_vm._s(_vm.$t("common.noPass"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("common.approvalRemarks"),
                    prop: "approvalRemarks",
                    rules:
                      _vm.approvaForm.approvalResults == "REJECT"
                        ? _vm.approvaForm.approvalRemarks
                        : [],
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 4 },
                      maxlength: "300",
                    },
                    model: {
                      value: _vm.approvaForm.approvalRemarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "approvalRemarks", $$v)
                      },
                      expression: "approvaForm.approvalRemarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.approvalVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.SubmitPotentialSupplier,
                      expression: "SubmitPotentialSupplier",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.approvalConfirm()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.addressAddSupplierContactListDialog,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addressAddSupplierContactListDialog = $event
            },
          },
        },
        [
          _vm.addressAddSupplierContactListForm.addresslinkUsersList.length <
            5 && _vm.canEdit
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.SubmitPotentialSupplier,
                      expression: "SubmitPotentialSupplier",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addSupplierContactsAddress()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.addNew")))]
              )
            : _vm._e(),
          _vm.canEdit || _vm.canUpdate
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.SubmitPotentialSupplier,
                      expression: "SubmitPotentialSupplier",
                    },
                  ],
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.delSupplierContactsAddress()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.del")))]
              )
            : _vm._e(),
          _c(
            "el-form",
            {
              ref: "addressAddSupplierContactListForm",
              attrs: {
                model: _vm.addressAddSupplierContactListForm,
                rules: _vm.rulesAddressAddSupplierContactList,
              },
            },
            [
              _c(
                "el-table",
                {
                  ref: "addresslinkUsersList",
                  attrs: {
                    data: _vm.addressAddSupplierContactListForm
                      .addresslinkUsersList,
                    border: "",
                    "highlight-current-row": "",
                    "max-height": "420",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "trLinkUserId",
                      type: "selection",
                      "min-width": "55",
                      selectable: (row) => !row.titleDisabled,
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "name",
                      label: _vm.$t("settlementUnit.contacts"),
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "addresslinkUsersList." +
                                    scope.$index +
                                    ".name",
                                  rules:
                                    _vm.rulesAddressAddSupplierContactList.name,
                                },
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    model: {
                                      value: scope.row.name,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "name", $$v)
                                      },
                                      expression: "scope.row.name",
                                    },
                                  },
                                  [_vm._v(" ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "tel",
                      label: _vm.$t("settlementUnit.tel"),
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "addresslinkUsersList." +
                                    scope.$index +
                                    ".tel",
                                  rules:
                                    _vm.rulesAddressAddSupplierContactList.tel,
                                },
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: { maxlength: "60" },
                                    model: {
                                      value: scope.row.tel,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "tel", $$v)
                                      },
                                      expression: "scope.row.tel",
                                    },
                                  },
                                  [_vm._v(" ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "officeTel",
                      label: "办公室电话",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "addresslinkUsersList." +
                                    scope.$index +
                                    ".officeTel",
                                  rules:
                                    _vm.rulesAddressAddSupplierContactList
                                      .officeTel,
                                },
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: { maxlength: "60" },
                                    model: {
                                      value: scope.row.officeTel,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "officeTel", $$v)
                                      },
                                      expression: "scope.row.officeTel",
                                    },
                                  },
                                  [_vm._v(" ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "email",
                      label: _vm.$t("sys.userList.email"),
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "addresslinkUsersList." +
                                    scope.$index +
                                    ".email",
                                  rules:
                                    _vm.rulesAddressAddSupplierContactList
                                      .email,
                                },
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: { maxlength: "50" },
                                    model: {
                                      value: scope.row.email,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "email", $$v)
                                      },
                                      expression: "scope.row.email",
                                    },
                                  },
                                  [_vm._v(" ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "title",
                      label: _vm.$t("supplierManage.position"),
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "addresslinkUsersList." +
                                    scope.$index +
                                    ".title",
                                  rules:
                                    _vm.rulesAddressAddSupplierContactList
                                      .title,
                                },
                              },
                              [
                                _vm.rowIndex == 0
                                  ? _c("ic-select", {
                                      attrs: {
                                        table: "TM_UNIT_OF_ACCOUNT",
                                        field: "REG_CONTACT_TYPE",
                                        disabled: scope.row.titleDisabled,
                                      },
                                      model: {
                                        value: scope.row.title,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "title", $$v)
                                        },
                                        expression: "scope.row.title",
                                      },
                                    })
                                  : _c("ic-select", {
                                      attrs: {
                                        table: "TM_UNIT_OF_ACCOUNT",
                                        field: "PLANT_CONTACT_TYPE",
                                        disabled: scope.row.titleDisabled,
                                      },
                                      model: {
                                        value: scope.row.title,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "title", $$v)
                                        },
                                        expression: "scope.row.title",
                                      },
                                    }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _vm.canEdit || _vm.canUpdate
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.SubmitPotentialSupplier,
                          expression: "SubmitPotentialSupplier",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.saveSupplierContactsAddress },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.save")))]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.addressAddSupplierContactListDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }